import axios from "../components/shared/axios";

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getReleaseNotes = async () => {
  return await axios.get(`${baseURL}/release-notes`);
};
